import React, { FunctionComponent } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { useTranslation } from 'react-i18next'

import './Modal.scss'
import { LocalLoader } from 'components/Common/Loaders'

interface Props {
  [key: string]: any,
}

const CustomModal: FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { title, modal, setModal, children, handleSubmit, isLoading, createText, className, scrollable, noCancel, onClosed, size = 'xl', loadingModal = false, showFooter = true, style = {}, directDelivery } = props

  const toggle = () => setModal(!modal);
  const handleCloseIcon = () => {
    if (!isLoading) {
      toggle()
    }
  }

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} backdrop={'static'} className={className} scrollable={scrollable} onClosed={onClosed} size={size} >
        <ModalHeader toggle={toggle} className='text-white bg-primary custom-modal-header'>
          {title}<i className={`fas fa-times ${isLoading && 'loading'}`} onClick={handleCloseIcon} title={t('common.close')}></i>
        </ModalHeader>
        <ModalBody id="modal-infinite-scroll-target" style={style}>
          {isLoading && <div className="feedback-layer modal-feedback-layer">
            <LocalLoader />
          </div>}
          {children}
        </ModalBody>
        {showFooter &&
          <ModalFooter>
            {!noCancel && <Button color="secondary" onClick={toggle} disabled={isLoading}>{t('common.cancel')}</Button>}
            {!directDelivery &&
              <Button color="primary" onClick={handleSubmit} disabled={isLoading || loadingModal}>{createText || t('common.create')}</Button>
            }
          </ModalFooter>
        }
      </Modal>
    </div>
  );
}

export default CustomModal;